import { render, staticRenderFns } from "./Edm.vue?vue&type=template&id=7c07b55a&scoped=true&"
import script from "./Edm.vue?vue&type=script&lang=js&"
export * from "./Edm.vue?vue&type=script&lang=js&"
import style0 from "./Edm.vue?vue&type=style&index=0&id=7c07b55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07b55a",
  null
  
)

export default component.exports